<template>
    <div class="relative z-content w-full">
        <!-- Single-component shell: SpeedtestResults renders the meter +
             results panel; this component owns the auto-start wiring.
             T2 — :current-test-progress prop removed; MeterColumn and PhaseTimeline
             now store-derive their progress directly. The currentPhaseProgress
             computed can be removed below. -->
        <SpeedtestResults />
    </div>
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import SpeedtestResults from "./SpeedtestResults.vue";
import { useAutoStart } from "../composables/useAutoStart.ts";
import { DockStartKey } from "@src/composables/keys.ts";
import { useSpeedtestStore } from "@features/speedtest/state/index.ts";

const speedtest = useSpeedtestStore();
const dockStart = inject(DockStartKey)!;

// T2 — currentPhaseProgress computed removed; progress is now derived
// in MeterColumn and PhaseTimeline directly from the store (store-derive at leaves).

// Auto-start on view entry once no test is running. `useAutoStart` is
// one-fire-per-mount. The injected `dockStart()` handles cellular
// preflight + session + start.
useAutoStart({
    shouldStart: computed(() => !speedtest.isRunning),
    onStart: () => dockStart(),
});
</script>
